export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cheerful%20crowd%20of%20young%20people%20gathered%20around%20watching%20a%20large%20glowing%20screen%20showing%20trending%20news%20timeline%20in%20flat%20illustration%2C%20warm%20cream%20beige%20background%2C%20watermelon%20red%20coral%20and%20leaf%20green%20color%20palette%2C%20soft%20rounded%20shapes%2C%20community%20and%20curiosity%20atmosphere%2C%20lively%20but%20clean%20minimal%20editorial%20style&width=1600&height=900&seq=hero-watermelon-2026&orientation=landscape"
          alt="吃瓜直播围观群众集合地品牌插画"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50"></div>
      </div>

      <div className="container-site relative flex min-h-[640px] flex-col items-center justify-center py-24 pt-32 text-center md:min-h-[680px]">
        <span className="chip mb-6 border border-primary-200 bg-background-50/80 px-4 py-1.5 text-primary-700 backdrop-blur-sm">
          <i className="ri-hotspot-line"></i> 全网围观群众集合地 · 蹲后续不迷路
        </span>
        <h1 className="font-heading text-4xl font-bold leading-tight text-foreground-950 md:text-5xl lg:text-[3.4rem]">
          吃瓜直播，<br className="md:hidden" />
          热门事件一站式围观
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          蹲后续、催更、求指路一次搞定。不知道瓜从哪吃起？吃瓜直播带带你——热门事件入口清晰，
          脉络按时间线整理，后续更新提醒到位，精彩片段一个都不错过。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            href="#board"
            className="btn bg-primary-500 px-6 py-3 text-sm text-background-50 hover:bg-primary-600 md:text-base"
          >
            <i className="ri-community-line"></i> 进去围观
          </a>
          <a
            href="#guide"
            className="btn border border-foreground-900/15 bg-background-50/80 px-6 py-3 text-sm text-foreground-900 backdrop-blur-sm hover:border-primary-300 hover:text-primary-700 md:text-base"
          >
            围观指南 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-12 grid w-full max-w-3xl grid-cols-3 gap-3 md:gap-4">
          {[
            { num: "120W+", label: "围观热度" },
            { num: "2600+", label: "正在蹲的帖" },
            { num: "38.9W", label: "每天提醒不漏" },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-background-200/80 bg-background-50/80 px-3 py-4 text-center backdrop-blur-sm"
            >
              <div className="font-heading text-xl font-bold text-primary-600 md:text-2xl">{s.num}</div>
              <div className="mt-1 text-xs text-foreground-600 md:text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}